import React from "react";
import { DatePicker, Space } from "antd";
import dayjs from "dayjs";
const { RangePicker } = DatePicker;

const DateTimeRangePicker = ({ onChange }) => {
  // const onChange = (date) => {
  //   if (date) {
  //     console.log("Date", date);
  //   } else {
  //     console.log("No date selected");
  //   }
  // };

  const onRangeChange = (dates, dateStrings) => {
    if (dates) {
      // Call the onChange prop with the selected dates
      console.log("From: ", dateStrings[0], ", to: ", dateStrings[1]);
       onChange({ dates, dateStrings });
    } else {
      console.log("Clear");
    }
  };

  const rangePresets = [
    { label: "Last 7 Days", value: [dayjs().add(-7, "d"), dayjs()] },
    { label: "Last 14 Days", value: [dayjs().add(-14, "d"), dayjs()] },
    { label: "Last 30 Days", value: [dayjs().add(-30, "d"), dayjs()] },
    { label: "Last 90 Days", value: [dayjs().add(-90, "d"), dayjs()] },
  ];
  return (
    <Space direction="vertical" size={12}>
      {/* Type 1: Single Date Picker */}
      {/* <DatePicker
      presets={[
        { label: 'Yesterday', value: dayjs().add(-1, 'd') },
        { label: 'Last Week', value: dayjs().add(-7, 'd') },
        { label: 'Last Month', value: dayjs().add(-1, 'month') },
      ]}
      onChange={onChange}
    /> */}

    {/* Type 2: Range Date Picker */}
      {/* <RangePicker presets={rangePresets} onChange={onRangeChange} /> */}

      {/* Type 3: Custom Range Picker with Presets */}
      <RangePicker
        size={"large"}
        presets={[
          {
            label: (
              <span aria-label="Current Time to End of Day">Now ~ EOD</span>
            ),
            value: () => [dayjs(), dayjs().endOf("day")], // 5.8.0+ support function
          },
          ...rangePresets,
        ]}
        showTime
        format="YYYY/MM/DD HH:mm:ss"
        onChange={onRangeChange}
      />
    </Space>
  );
};

export default DateTimeRangePicker;
